import {
  Zap,
  PlugZap,
  HardHat,
  Sun,
  TrainFront,
  Building2,
  Package,
} from "lucide-react";

export const INDUSTRIES = [
  {
    icon: Zap,
    title: "Power Transmission",
    clients: "State Transcos & Grid Substation Projects",
    need: "66kV & 33kV fail-safe terminations, cold-shrink reliability and zero-downtime joints for trunk networks.",
  },
  {
    icon: PlugZap,
    title: "Utilities & DISCOMs",
    clients: "State Electricity Boards & Distribution Companies",
    need: "11kV/33kV underground conversion, compact RMU connections and weather-proof jointing kits for urban feeders.",
  },
  {
    icon: HardHat,
    title: "EPC Contractors",
    clients: "Turnkey Power & Infrastructure EPC",
    need: "Bulk ready-stock availability, fast delivery to project sites and complete type-test documentation.",
  },
  {
    icon: Sun,
    title: "Solar EPCs",
    clients: "Utility-Scale Solar Parks & Wind Farms",
    need: "UV-resistant outdoor terminations, aluminium-cable compatibility and ACSR protective insulation.",
  },
  {
    icon: TrainFront,
    title: "Rail, Metro & Infrastructure",
    clients: "Metro Corporations, Railways & Airports",
    need: "Fire-retardant tapes, LSZH-friendly accessories and resin systems for safety-critical environments.",
  },
  {
    icon: Building2,
    title: "Builders & Industry",
    clients: "High-rises, Data Centers, Refineries & Plants",
    need: "Reliable power tap-offs, anti-tracking insulation in corrosive environments and immediate dispatch.",
  },
  {
    icon: Package,
    title: "Traders & Distributors",
    clients: "Electrical Traders Across India",
    need: "Genuine 3M channel-partner stock, trade quantities and dependable Bhagirath Palace supply lines.",
  },
];
